import { useEffect } from 'react';

interface SEOHeadProps {
  schema?: Record<string, unknown>;
}

export default function SEOHead({ schema }: SEOHeadProps) {
  useEffect(() => {
    if (!schema) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [schema]);

  return null;
}